module.exports = __webpack_public_path__ + "static/media/winter.f03cd0cf.png";